import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import TabSection from '../../components/feature/TabSection';
import Sidebar from '../../components/feature/Sidebar';
import Footer from '../../components/feature/Footer';
import { supabase, BlogPost } from '../../lib/supabase';

export default function Home() {
  const [articles, setArticles] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublishedArticles();
  }, []);

  const fetchPublishedArticles = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('blog_posts')
        .select('*')
        .eq('is_published', true)
        .order('sort_order', { ascending: true })
        .order('published_date', { ascending: false })
        .limit(9);

      if (error) throw error;
      setArticles(data || []);
    } catch (error) {
      console.error('記事の取得に失敗しました:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <HeroSection />
      
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <TabSection articles={articles} loading={loading} />
          </div>
          <div className="lg:flex-shrink-0">
            <Sidebar />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
